import React, { FC, PropsWithChildren, ReactNode } from 'react';

import { Stack } from '../Stack';
import { Box } from '../Box';
import { Typography, TypographyProps } from '../Typography';
import { PaletteColor } from '../../palette';


type IconVariant = 'red' | 'green';

const ICON_COLORS: Record<IconVariant, Record<'main' | 'shadow', PaletteColor>> = {
    green: {
        main: 'infoCustom.green50',
        shadow: 'infoCustom.green10',
    },
    red: {
        main: 'infoCustom.red50',
        shadow: 'infoCustom.red10',
    },
};

export interface StubProps {
    iconVariant?: IconVariant;
    title?: ReactNode;
    titleVariant?: TypographyProps['variant'];
    subtitle?: ReactNode;
    footer?: ReactNode;
    Icon: FC;
}
export const Stub: FC<PropsWithChildren<StubProps>> = ({
    children, iconVariant = 'green', subtitle, title, titleVariant = 'boldTitle5', Icon,
}) => (
    <Stack
        alignItems='center'
        bgcolor='grayscale.shade0'
        px={8}
        py={10}
        borderRadius={8}
        width={({ spacing }) => spacing(120)}
        flexGrow={0}
    >
        <Box
            borderRadius={25}
            bgcolor={ICON_COLORS[iconVariant].shadow}
            p={4}
            lineHeight={0}
        >
            <Box
                borderRadius={25}
                bgcolor={ICON_COLORS[iconVariant].main}
                color='grayscale.shade0'
                p={4}
                sx={{
                    '& > svg': {
                        fontSize: ({ spacing }) => spacing(8),
                    },
                }}
            >
                <Icon />
            </Box>
        </Box>
        {title && (
            <Typography
                component='h3'
                variant={titleVariant}
                color='grayscale.shade95'
                textAlign='center'
                mt={4}
            >
                {title}
            </Typography>
        )}
        {subtitle && (
            <Typography
                component='p'
                variant='regularBody2'
                color='grayscale.shade90'
                mt={2}
                textAlign='center'
            >
                {subtitle}
            </Typography>
        )}
        {children && (
            <Box mt={4}>
                {children}
            </Box>
        )}
    </Stack>
);
